import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { Container, CoreLink, VideoWithOverlay } from '../../../../components';

import './style.scss';

const HomepageVideo = ({ entity }) => {
  const { t } = useTranslation();
  const desktopVideo = entity.getIn(['field_video', 0, 'source'], '');
  const mobileVideo = entity.getIn(['field_video_mobile', 0, 'source'], '');
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed'], '');
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkUri = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;
  const { ref, inView } = useInView();

  return (
    <div id={paragraphKey} className="Paragraph HomepageVideo" ref={ref}>
      {(body || title) && (
        <Container>
          <div className="HomepageVideo__introWrapper">
            {title && <h2>{title}</h2>}
            {body && (
              <WysiwygField
                property="schema:text"
                html={body}
              />
            )}
          </div>
        </Container>
      )}

      {desktopVideo &&
        <VideoWithOverlay
          buttonText={t('show_the_video')}
          desktopVideo={desktopVideo}
          mobileVideo={mobileVideo}
          inView={inView}
        />}

      {linkTitle && linkUri && (
        <Container>
          <CoreLink
            className="HomepageVideo__cta Button Button--primary Button--icon icon-after icon-arrow-right icon-before moving-arrow icon-variant-4"
            to={linkUri}
          >
            {linkTitle}
          </CoreLink>
        </Container>
      )}
    </div>
  );
};

export default HomepageVideo;
